/**
 * Melian Dialogue — country code + phone-format registry.
 * African-first ordering, then global majors. Shared by the Contact page
 * and the Register page so both enforce identical dynamic regex rules.
 *
 * Mirrors /app/backend/services/phone_validation.py — keep both in lock-step.
 */
export const COUNTRIES = [
    // ── Africa (priority) ──────────────────────────────────────
    { iso2: "KE", name: "Kenya",            dial: "+254", nsn: [9, 9],   regex: /^[17]\d{8}$/ },
    { iso2: "UG", name: "Uganda",           dial: "+256", nsn: [9, 9] },
    { iso2: "TZ", name: "Tanzania",         dial: "+255", nsn: [9, 9] },
    { iso2: "RW", name: "Rwanda",           dial: "+250", nsn: [9, 9] },
    { iso2: "BI", name: "Burundi",          dial: "+257", nsn: [8, 8] },
    { iso2: "SS", name: "South Sudan",      dial: "+211", nsn: [9, 9] },
    { iso2: "ET", name: "Ethiopia",         dial: "+251", nsn: [9, 9] },
    { iso2: "SO", name: "Somalia",          dial: "+252", nsn: [8, 8] },
    { iso2: "DJ", name: "Djibouti",         dial: "+253", nsn: [6, 8] },
    { iso2: "ER", name: "Eritrea",          dial: "+291", nsn: [7, 7] },
    { iso2: "NG", name: "Nigeria",          dial: "+234", nsn: [10, 10] },
    { iso2: "GH", name: "Ghana",            dial: "+233", nsn: [9, 9] },
    { iso2: "ZA", name: "South Africa",     dial: "+27",  nsn: [9, 9] },
    { iso2: "EG", name: "Egypt",            dial: "+20",  nsn: [10, 10] },
    { iso2: "MA", name: "Morocco",          dial: "+212", nsn: [9, 9] },
    { iso2: "DZ", name: "Algeria",          dial: "+213", nsn: [9, 9] },
    { iso2: "TN", name: "Tunisia",          dial: "+216", nsn: [8, 8] },
    { iso2: "LY", name: "Libya",            dial: "+218", nsn: [9, 9] },
    { iso2: "SD", name: "Sudan",            dial: "+249", nsn: [9, 9] },
    { iso2: "SN", name: "Senegal",          dial: "+221", nsn: [9, 9] },
    { iso2: "CI", name: "Côte d'Ivoire",    dial: "+225", nsn: [10, 10] },
    { iso2: "ML", name: "Mali",             dial: "+223", nsn: [8, 8] },
    { iso2: "BF", name: "Burkina Faso",     dial: "+226", nsn: [8, 8] },
    { iso2: "NE", name: "Niger",            dial: "+227", nsn: [8, 8] },
    { iso2: "TG", name: "Togo",             dial: "+228", nsn: [8, 8] },
    { iso2: "BJ", name: "Benin",            dial: "+229", nsn: [8, 8] },
    { iso2: "GM", name: "Gambia",           dial: "+220", nsn: [7, 7] },
    { iso2: "SL", name: "Sierra Leone",     dial: "+232", nsn: [8, 8] },
    { iso2: "LR", name: "Liberia",          dial: "+231", nsn: [8, 9] },
    { iso2: "CM", name: "Cameroon",         dial: "+237", nsn: [9, 9] },
    { iso2: "GA", name: "Gabon",            dial: "+241", nsn: [7, 8] },
    { iso2: "CG", name: "Congo (Rep.)",     dial: "+242", nsn: [9, 9] },
    { iso2: "CD", name: "DR Congo",         dial: "+243", nsn: [9, 9] },
    { iso2: "AO", name: "Angola",           dial: "+244", nsn: [9, 9] },
    { iso2: "ZM", name: "Zambia",           dial: "+260", nsn: [9, 9] },
    { iso2: "ZW", name: "Zimbabwe",         dial: "+263", nsn: [9, 9] },
    { iso2: "MW", name: "Malawi",           dial: "+265", nsn: [9, 9] },
    { iso2: "MZ", name: "Mozambique",       dial: "+258", nsn: [9, 9] },
    { iso2: "BW", name: "Botswana",         dial: "+267", nsn: [8, 8] },
    { iso2: "NA", name: "Namibia",          dial: "+264", nsn: [9, 9] },
    { iso2: "LS", name: "Lesotho",          dial: "+266", nsn: [8, 8] },
    { iso2: "SZ", name: "Eswatini",         dial: "+268", nsn: [8, 8] },
    { iso2: "MG", name: "Madagascar",       dial: "+261", nsn: [9, 9] },
    { iso2: "MU", name: "Mauritius",        dial: "+230", nsn: [7, 8] },
    { iso2: "SC", name: "Seychelles",       dial: "+248", nsn: [7, 7] },
    // ── Global majors ──────────────────────────────────────────
    { iso2: "US", name: "United States",    dial: "+1",   nsn: [10, 10] },
    { iso2: "GB", name: "United Kingdom",   dial: "+44",  nsn: [10, 10] },
    { iso2: "CA", name: "Canada",           dial: "+1",   nsn: [10, 10] },
    { iso2: "IN", name: "India",            dial: "+91",  nsn: [10, 10] },
    { iso2: "CN", name: "China",            dial: "+86",  nsn: [11, 11] },
    { iso2: "DE", name: "Germany",          dial: "+49",  nsn: [10, 11] },
    { iso2: "FR", name: "France",           dial: "+33",  nsn: [9, 9] },
    { iso2: "AE", name: "United Arab Emirates", dial: "+971", nsn: [9, 9] },
    { iso2: "SA", name: "Saudi Arabia",     dial: "+966", nsn: [9, 9] },
    { iso2: "AU", name: "Australia",        dial: "+61",  nsn: [9, 9] },
    { iso2: "BR", name: "Brazil",           dial: "+55",  nsn: [10, 11] },
    { iso2: "PK", name: "Pakistan",         dial: "+92",  nsn: [10, 10] },
];

export function findCountry(dial) {
    return COUNTRIES.find((c) => c.dial === dial) || null;
}

/** Unicode regional-indicator flag emoji from an ISO2 code (e.g. "KE" -> 🇰🇪). */
export function flagEmoji(iso2) {
    if (!iso2 || iso2.length !== 2) return "";
    return iso2.toUpperCase().replace(/./g, (c) => String.fromCodePoint(127397 + c.charCodeAt(0)));
}

/** Build a dynamic RegExp for the given dial code — falls back to a generic
 * digit-length check for any country not given an explicit `regex`. */
export function regexForDial(dial) {
    const c = findCountry(dial);
    if (!c) return /^\d{6,14}$/;
    if (c.regex) return c.regex;
    const [min, max] = c.nsn;
    return min === max ? new RegExp(`^\\d{${min}}$`) : new RegExp(`^\\d{${min},${max}}$`);
}

export function isValidNationalNumber(dial, national) {
    const digits = String(national || "").replace(/\D/g, "");
    return regexForDial(dial).test(digits);
}
